import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Container,
  Card,
  Spinner,
  Row,
  Col,
  OverlayTrigger,
} from 'react-bootstrap';
import StyledText from '../../../app/components/styledComponents/StyledText';
import StyledCheckIcon from '../../../app/components/styledComponents/StyledCheckIcon';
import InfoIcon from '../../../app/components/svgIcons/InfoIcon';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import {
  useGetTemplateSelectedDataQuery,
  useGetTemplatedataQuery,
  useUpdateTemplateDataMutation,
} from '../../vendors/vendorsApiSlice';
import { useGetAccountConnectedQuery } from '../../shopSetting/shopAPISlice';
import EyeIcon from '../../../app/components/svgIcons/EyeIcon';
import { TemplateTheming } from '../EditAndPreviewTemplate/assets/templateThemingStyled';
import MetaSVG from '../assets/metaSVG';
import ThemeSVG from '../assets/themeSVG';
import AnalyticsSVG from '../assets/analytics';
import EditIcon from '../EditAndPreviewTemplate/assets/editIcon';
import { selectBasicInformation, setUserBasicInfo } from '../../auth/authSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { ShopStyled } from '../../shopSetting/assets/shopStyled';
import DomainRegistrationModal from './DomainRegistrationModal';
import { useGetUserDetailsQuery } from '../../profile/profileApiSlice';
import { getColor, isAuthorized } from '../../../utils/helper';
import StyledLoading from '../../../app/components/loading/StyledLoading';
import { StyledTooltip } from '../../../app/components/styledComponents/StyledTooltip';

const StyledCard = styled(Card)`
  margin: 0;
  border: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-5px);
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 1.9rem;
  margin-bottom: 24px;
`;

const CardImage = styled.div`
   height: 340px;
   img {
     height: 100%;
     width: 100%
     object-fit: cover;
   }
`;

const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 16px 5px;
  flex-wrap: wrap;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  height: 48px;
`;

const ViewButton = styled.div`
  display: flex;
  padding: 9.5px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16),
    0px 0px 4px 0px rgba(0, 0, 0, 0.16);
  color: ${({ theme }) => theme.heading};
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  height: 48px;
  cursor: pointer;
`;

const SelectButton = styled(StyledButton)`
  color: #fff;
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  height: 48px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16),
    0px 0px 4px 0px rgba(0, 0, 0, 0.16);
`;

const LinkButton = styled(StyledButton)`
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  height: 48px;
  border: none !important;
  background: none !important;

  :hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const SVGImage = styled.div`
  height: 230px;
  display: fled;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.dark95};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;

  svg {
    max-width: 90%;
  }
`;

const TopInfoBox = styled(Row)`
  display: flex;
  height: 400px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  margin-bottom: 24px;
  padding: 48px;
  margin-left: 0px;
  gap: 48px;
`;

const SelectedImage = styled(Col)`
   height: 100%;
   border-radius: 8px;
   box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
   img {
     height: 100%;
     width: 100%
     object-fit: cover;
   }
`;

const ThemeInfoContainer = styled(Col)`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
`;

const StyledTag = styled.div`
  padding: 3px 20px;
  font-size: 18px;
  background-color: ${({ theme, colorHex, color }) =>
    colorHex ? colorHex : color ? getColor(color, theme) : theme.primary};
  color: #ffffff;
  font-size: 500;
  font-family: ${(theme) => theme.fontFamily};
  display: flex;
  align-self: center;
  border-radius: 0 0 8px 8px;
`;

const StyledInfoIcon = styled(InfoIcon)`
  * {
    color: ${({ theme, color }) =>
      color ? getColor(color, theme) : theme.primary}!important;
    opacity: 1;
  }
`;
const aryEditOption = ['Meta & SEO', 'Site Settings', 'Analytics'];

const ThemeSelection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const basicInfo = useSelector(selectBasicInformation);
  const {
    data: templateSelectedData,
    isFetching: loadData,
    refetch: getTemplateData,
  } = useGetTemplateSelectedDataQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const { data: connectedAccount, isLoading: isChecking } =
    useGetAccountConnectedQuery(null, {
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
    });
  const { data: userDetails, refetch: getFloristDetails } =
    useGetUserDetailsQuery({ forceRefetch: true });
  const { data: templateData, isLoading: loadTemplate } =
    useGetTemplatedataQuery(null, {
      skip: loadData || templateSelectedData?.id,
    });
  const [addTemplateAPI, { isLoading: addLoading }] =
    useUpdateTemplateDataMutation();
  const [selectedTemplate, setSelectedTemplate] = useState(undefined);
  const [showModal, setShowModal] = useState(false);

  const userPermissions = useSelector(
    (state) => state?.authorization?.userPermissions,
  );

  const has_permission_to_edit_website = isAuthorized(
    userPermissions,
    'can_edit_website',
  );

  useEffect(() => {
    getTemplateData && getTemplateData();
  }, []);

  useEffect(() => {
    if (templateSelectedData && templateSelectedData?.pages !== undefined) {
      setSelectedTemplate(templateSelectedData);
    }
  }, [templateSelectedData]);

  const goToNextView = async (tempData) => {
    if (selectedTemplate?.templateId === tempData?.templateId) {
      navigate('/editTemplate');
    } else {
      var tData = { ...tempData };
      if (selectedTemplate) {
        tData.id = selectedTemplate.id;
        // tData.pages = selectedTemplate.pages;
      }
      const { data } = await addTemplateAPI(tData);
      if (!data?.error) {
        dispatch(
          setUserBasicInfo({
            values: {
              usingWebHosting: true,
            },
          }),
        );
        setSelectedTemplate(data?.objectData);
        navigate('/editTemplate');
      }
    }
  };

  const goToMetaEditView = (title) => {
    if (title === 'Meta & SEO' || title === 'Analytics') return;
    let type = 'seo';
    if (title === 'Site Settings') {
      type = 'setting';
    } else if (title === 'Analytics') {
      type = 'chart';
    }

    navigate('/editTemplate', {
      state: {
        type: type,
        key: title,
      },
    });
  };

  return (
    <ShopStyled.PageWrap isFullWidth>
      {!selectedTemplate && (
        <Container fluid>
          <Row className="g-3">
            {templateData?.map((card, index) => (
              <Col xs={12} md={6}>
                <StyledCard key={index}>
                  <CardImage>
                    <Card.Img src={card?.imageUrl} />
                  </CardImage>

                  <Card.Body className="px-0 pb-2">
                    <BottomContainer>
                      <StyledText
                        as="h5"
                        $fontSize="20px"
                        color="heading"
                        $fontWeight="600"
                      >
                        {card?.name}
                      </StyledText>
                      <ButtonContainer>
                        <a
                          href={card?.redirectUrl ? card?.redirectUrl : '#'}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <ViewButton>
                            <EyeIcon className="me-1" />
                            View
                          </ViewButton>
                        </a>
                        <SelectButton onClick={() => goToNextView(card)}>
                          Select
                        </SelectButton>
                      </ButtonContainer>
                    </BottomContainer>
                  </Card.Body>
                </StyledCard>
              </Col>
            ))}
          </Row>
        </Container>
      )}

      {selectedTemplate && (
        <Container fluid>
          <TopInfoBox>
            <SelectedImage>
              <Card.Img src={selectedTemplate?.imageUrl} />
            </SelectedImage>
            <ThemeInfoContainer>
              <div style={{ height: '200px' }}>
                <StyledText
                  as="h5"
                  $fontSize="30px"
                  color="heading"
                  $fontWeight="600"
                >
                  Web Template: {selectedTemplate?.name}
                </StyledText>
                <div className="d-flex align-items-center">
                  <StyledText
                    as="h6"
                    $fontSize="24px"
                    color="heading"
                    $fontWeight="600"
                  >
                    Domain:
                  </StyledText>

                  <StyledText
                    as="a"
                    $fontSize="18px"
                    color="bodyMedium"
                    $fontWeight="400"
                    style={{ marginLeft: '10px' }}
                    href={basicInfo?.website ? basicInfo?.website : '#'}
                    target="_blank"
                  >
                    {basicInfo?.website}
                  </StyledText>

                  <StyledText
                    as="h6"
                    $fontSize="18px"
                    color={
                      userDetails?.floristDTO?.domainRegistered
                        ? 'success'
                        : 'danger'
                    }
                    $fontWeight="400"
                    style={{ marginLeft: '10px' }}
                  >
                    {`(${
                      userDetails?.floristDTO?.domainRegistered
                        ? 'Registered'
                        : 'Not Registered'
                    })`}
                  </StyledText>
                </div>
                <div className="d-flex align-items-center">
                  <StyledText
                    as="h6"
                    $fontSize="24px"
                    color="heading"
                    $fontWeight="600"
                  >
                    Preview Site:
                  </StyledText>

                  <StyledText
                    as="a"
                    $fontSize="18px"
                    color="bodyMedium"
                    $fontWeight="400"
                    style={{ marginLeft: '10px' }}
                    href={
                      basicInfo?.subdomainUrl ? basicInfo?.subdomainUrl : '#'
                    }
                    target="_blank"
                  >
                    {/* <a href={basicInfo?.subdomainUrl ? basicInfo?.subdomainUrl : '#'} target='_blank'> */}
                    {basicInfo?.subdomainUrl}
                    {/* </a> */}
                  </StyledText>
                </div>

                {typeof connectedAccount === 'string' && !isChecking && (
                  <div className="d-flex align-items-center">
                    <StyledText
                      as="p"
                      $fontSize="18px"
                      color="warning"
                      $fontWeight="400"
                      onClick={() => navigate('/shopInfo/financials')}
                      className="cursor-pointer"
                    >
                      Configure your Account for Receiving Payments
                    </StyledText>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-between w-100">
                <OverlayTrigger
                  overlay={
                    has_permission_to_edit_website ? (
                      <></>
                    ) : (
                      <StyledTooltip>
                        You do not have permission to edit website
                      </StyledTooltip>
                    )
                  }
                >
                  <div>
                    <SelectButton
                      onClick={() => navigate('/editTemplate')}
                      disabled={!has_permission_to_edit_website}
                    >
                      <EditIcon className="me-1" />
                      Edit Site
                    </SelectButton>
                  </div>
                </OverlayTrigger>
                <LinkButton onClick={() => setShowModal(true)}>
                  <div>
                    {!userDetails?.floristDTO?.domainRegistered ? (
                      <p>Register Domain</p>
                    ) : (
                      <div className="d-flex gap-1 align-items-center">
                        <div>
                          <StyledText
                            as="h6"
                            className="m-0 text-end"
                            $fontSize="18px"
                            color={
                              userDetails?.floristDTO?.domainRegistered
                                ? 'success'
                                : 'danger'
                            }
                            $fontWeight="500"
                            style={{ marginLeft: '10px' }}
                          >
                            Domain Registered
                          </StyledText>
                          {!userDetails?.floristDTO?.nameserversUpdated && (
                            <StyledText
                              as="h6"
                              className="m-0 text-end"
                              $fontSize="18px"
                              color={
                                userDetails?.floristDTO?.nameserversUpdated
                                  ? 'success'
                                  : 'danger'
                              }
                              $fontWeight="500"
                              style={{ marginLeft: '10px' }}
                            >
                              (Pending nameservers update)
                            </StyledText>
                          )}
                        </div>
                        {!userDetails?.floristDTO?.nameserversUpdated ? (
                          <StyledInfoIcon
                            color={
                              userDetails?.floristDTO?.nameserversUpdated
                                ? 'success'
                                : 'danger'
                            }
                            size={35}
                          />
                        ) : (
                          <StyledCheckIcon color={'success'} />
                        )}
                      </div>
                    )}
                  </div>
                </LinkButton>
              </div>
            </ThemeInfoContainer>
          </TopInfoBox>
          <Grid>
            {aryEditOption?.map((title, index) => (
              <StyledCard key={index} className="position-relative">
                <SVGImage>
                  {index === 0 && <MetaSVG />}
                  {index === 1 && <ThemeSVG />}
                  {index === 2 && <AnalyticsSVG />}
                </SVGImage>

                <Card.Body className="px-0 pb-2">
                  <BottomContainer>
                    <StyledText
                      as="h5"
                      $fontSize="20px"
                      color="heading"
                      $fontWeight="600"
                    >
                      {title}
                    </StyledText>

                    <ButtonContainer>
                      <SelectButton
                        disabled={
                          title === 'Meta & SEO' || title === 'Analytics'
                        }
                        onClick={() => goToMetaEditView(title)}
                      >
                        <EditIcon className="me-1" />
                        Edit
                      </SelectButton>
                    </ButtonContainer>
                  </BottomContainer>
                </Card.Body>
                {(title === 'Meta & SEO' || title === 'Analytics') && (
                  <div className="position-absolute top-0 end-0">
                    <StyledTag>Coming Soon</StyledTag>
                  </div>
                )}
              </StyledCard>
            ))}
          </Grid>
        </Container>
      )}

      {(loadData || loadTemplate || addLoading) && (
        <TemplateTheming.LoaderBg>
          <StyledLoading />
        </TemplateTheming.LoaderBg>
      )}

      <DomainRegistrationModal
        open={showModal}
        onHide={() => setShowModal(false)}
        website={basicInfo?.website}
        userDetails={userDetails}
        refetchUserDetails={getFloristDetails}
      />
    </ShopStyled.PageWrap>
  );
};

export default ThemeSelection;
